import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid';
import FormDatePicker from '../../components/DatePicker';
import FormControl from '@material-ui/core/FormControl';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import { Button, ThemeProvider } from "@material-ui/core";
import MaterialTable from "material-table";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useSelector, useDispatch } from "react-redux";

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const apirpt = axios.create({
    baseURL: `WorkCenterLossSummary`
})


function WorkCenterSummary() {
    var columns = [
        { title: 'id', field: 'id', hidden: true },
        { title: "Entry Number", field: "viewEntryNumber" },
        { title: 'Entry Date', field: 'entryDate', type: 'date', dateSetting: { locale: "en-GB" }, },
        { title: "Shift", field: "shiftName" },
        { title: "MRP Controller", field: "mrpcontroller" },
        { title: "Status", field: "statusName" },
    ]
    const [data, setData] = useState([]); //table data
    //const [mrpController, setMrpController] = React.useState('');
    //const [workctr, setWorkctr] = React.useState('');
   
    //for error handling
    const [iserror, setIserror] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])
    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);

    //for progress
    const [openLoader, setopenLoader] = useState(false);

    //for alert showing
    const [open, setopen] = useState('');
    const [openAlert, setopenAlert] = useState('');
    const [openClassName, setopenClassName] = useState('');
    const [openType, setopenType] = useState('');

    //const [alertsuccess, setalertsuccess] = useState("Success");
    const [alerterror] = useState("Alert");
    //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    const [alerterrorclass] = useState("bg-red clr-white");
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);

    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }

    function handleClose() {
        setopen(false);
    }

    function dateChangeEvent(dateValue, label) {
        if (label === "From Date") {
            if (todate !== null) {
                if ((Date.parse(dateValue) > Date.parse(todate))) {
                    showMsg(true, "From date should be less than To date", alerterrorclass, alerterror);
                    setFromdate(null);
                }
                else {
                    setFromdate(dateValue);
                }
            }
            else {
                setFromdate(dateValue);
            }
        }
        else if (label === "To Date") {
            if ((Date.parse(fromdate) > Date.parse(dateValue))) {
                showMsg(true, "From date should be greater than To date", alerterrorclass, alerterror);
                setTodate(null);
            }
            else {
                setTodate(dateValue);
            }
        }
    }

    function GetFilterSlipSummary() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        setopenLoader(true);
        let slipDet = {
            FromDate: fromdate,
            ToDate: todate
        }
        apirpt.post("/getWorkCenterLossSummaryList/", slipDet,{
            headers: headers
        })
            .then(res => {
                setData(res.data);
                //console.log(res.data);
                setopenLoader(false);
            })
            .catch(error => {
                console.log("Error in hitting api : getWorkCenterLossSummaryList");
                setopenLoader(false);
            })
    }

    const SearchTable = (event) => {
        GetFilterSlipSummary();
    };    

    useEffect(() => {
        GetFilterSlipSummary();
    }, [])
    

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data mt-2">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">Work Center Summary</h3>
                </Box>
               
                <Grid container spacing={1} className="d-flex jc-space-bt mt-1">
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl className="width-100 mt-05">
                            <FormDatePicker
                                id="FromDate"
                                placeholder="From Date"
                                label="From Date"
                                value={fromdate}
                                onChange={dateChangeEvent}
                                disablefuturedate={true}
                                required={true}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl className="width-100 mt-05">
                            <FormDatePicker
                                id="ToDate"
                                placeholder="To Date"
                                label="To Date"
                                value={todate}
                                onChange={dateChangeEvent}
                                disablefuturedate={true}
                                required={true}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={1} className="d-flex mt-05">
                        <Tooltip title="Filter Result" placement="right" arrow onClick={SearchTable}>
                            <Button className="download-icon" startIcon={<FilterList />}>
                            </Button>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={5} className="d-flex Width-100">
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex Width-100">
                        <a href="../WorkCenterLossesForm">
                            <Button item className="ns-btn-primary mt-1">
                                <span>Add</span>
                            </Button>
                        </a>
                    </Grid>
                    <Grid item xs={12}>
                        {iserror &&
                            <Alert severity="error">
                                {errorMessages.map((msg, i) => {
                                    return <div key={i}>{msg}</div>
                                })}
                            </Alert>
                        }
                        <MaterialTable
                            title=""
                            columns={columns}
                            data={data}
                            icons={tableIcons}                        
                            options={{
                                pageSizeOptions: [30, 40, 50],    // rows selection options
                                pageSize: 30,
                                exportAllData: true,
                                exportButton: true,
                                maxBodyHeight: 600,
                            }}
                            actions={[
                                rowData => ({
                                    icon: () => <Link to={"/WorkCenterLossesForm?ID=" + `${window.btoa(rowData.id)}`}><EditOutlinedIcon fontSize="small" /></Link>,
                                    tooltip: 'Edit',
                                    onClick: (rowData),
                                })
                            ]}
                            editable={{
                          
                            }}
                        />
                    </Grid>
                </Grid>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess">
                    <DialogTitle className={openClassName} style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {openType}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="clr-black">
                            {openAlert}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">OK</span>
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}

export default WorkCenterSummary;